<template>
  <main id="app">
    <mobile-btn @click="showMenu()"/>

    <header v-scroll="handleScroll">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 col-md-4">
            <div class="logo">
              <img src="/img/logo-novos.png" alt="NOVOS Logo" width="50%">
            </div>
          </div>
          <div class="col-12 col-md-8">
            <nav :class="{active: menuActive}">
              <ul>
                <li>
                  <a @click="ctaWrapper('topBar')">Download now for PC</a>
                </li>
                <li>
                  <a href="#training">Practice Fortnite</a>
                </li>
                <li>
                  <a href="#contact">Contact Us</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>

    <section class="main-block">
      <div class="container my-auto">
        <div class="row">
          <div class="col-12 text-center">
            <h1>Practice. Compete. Win V-Bucks!</h1>
            <div class="h4">The desktop app that will take your fortnite skills to the next level <br/><br/>
            Join challenges and win V-Bucks every week!</div>
            <a @click="ctaWrapper('header')" class="btn mt-60">Download NOVOS for free</a>
          </div>
        </div>
      </div>
      <div class="news-list w-100 text-center">
        <div class="h4">
          NOVOS in the news
        </div>
          <div class="news-list__item" v-for="(slide, idx) in newsSlider" :key="`n-slide-${idx}`">
            <a :href="slide.href" target="_blank">
              <img :src="slide.image">
            </a>
          </div>
      </div>
    </section>

    <section class="icons-list" id="about">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4 text-center icons-list__item">
            <img src="/img/icon_1.png">
            <div>
              <strong>Analyze</strong> your Gameplay
            </div>
          </div>
          <div class="col-12 col-md-4 text-center icons-list__item">
            <img src="/img/icon_2.png">
            <div>
              Get your
              <strong>personalized</strong> training plan
            </div>
          </div>
          <div class="col-12 col-md-4 text-center icons-list__item">
            <img src="/img/icon_3.png">
            <div>
              Win and 
              <strong>earn V-bucks!</strong>
            </div>
          </div>
          <div class="col-12 text-center mt-40">
            <a @click="ctaWrapper('startTrainingNow')" class="btn">Start training now</a>
          </div>
        </div>
      </div>
    </section>

    <template v-for="(article, idx) in articles">
      <section class="article-list__item">
        <div class="container">
          <div class="row" v-if="(idx + 1) % 2 !== 0">
            <div class="col-12 col-md-5 col-lg-4 article-list__text">
              <div class="h3">{{ article.title }}</div>
              <p>{{ article.text }}</p>
              <a @click="ctaWrapper(`featureBlock-${article.title}`)">Start training</a>
            </div>
            <div
              class="article-list__img right-img"
              :style="`background-image: url('${article.image}')`"
            ></div>
          </div>
          <div class="row justify-content-end" v-else>
            <div
              class="article-list__img left-img"
              :style="`background-image: url('${article.image}')`"
            ></div>
            <div class="col-12 col-md-5 col-lg-5 article-list__text">
              <div class="h3">{{ article.title }}</div>
              <p>{{ article.text }}</p>
              <a @click="ctaWrapper(`featureBlock-${article.title}`)">Start training</a>
            </div>
          </div>
        </div>
      </section>
    </template>

     <section class="training-sessions" id="training">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="h2 text-center">Thousands of training sessions</div>
            <p class="text-center">New Fortnite classes every week</p>
          </div>
          <div class="col-12 text-center">
            <a @click="ctaWrapper('trainingSessions')" class="btn mt-20">Start training now</a>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-100">
        <div class="row">
          <div class="col-12">
            <swiper :options="trainingOption" ref="trainingSwiper">
              <!-- slides -->
              <swiper-slide v-for="(slide, idx) in trainingSlider" :key="`slide-${idx}`">
                <div
                  class="training-sessions__item"
                  :style="`background-image: url(${slide.image})`"
                >
                  <div class="h3">{{ slide.title }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <section class="reviews">
      <div class="triangle triangle--1">
        <img src="/img/triangle2.svg">
      </div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="h2 text-center">We love our players, and they love us</div>
          </div>
          <div class="d-none d-md-block col-md-1">
            <div class="slider-btn slider-btn--prev">
              <img src="/img/slider-btn.svg">
            </div>
          </div>
          <div class="col-md-10">
            <swiper :options="reviewsOption" ref="reviewsSwiper" class="pb-100">
              <!-- slides -->
              <swiper-slide v-for="(slide, idx) in reviewsSlider" :key="`r-slide-${idx}`">
                <div class="review-content">
                  <div class="review-content__img">
                    <img :src="slide.image">
                  </div>
                  <div class="review-content__text">
                    <p>{{ slide.text }}</p>
                    <span>{{ slide.author }}</span>
                  </div>
                </div>
              </swiper-slide>
              <!-- Add Pagination -->
              <div class="swiper-pagination custom-bullets" slot="pagination"></div>
            </swiper>
          </div>
          <div class="d-none d-md-block col-md-1">
            <div class="slider-btn slider-btn--next">
              <img src="/img/slider-btn.svg">
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer id="contact">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="h2 text-center">Contact Us</div>
          </div>
          <div class="col-12 col-lg-10">
            <form autocomplete="off" v-if="!successSent">
              <div class="form-group">
                <label>Your name</label>
                <input v-model="formData.name" placeholder="Enter your name" autocomplete="off">
              </div>
              <div class="form-group">
                <label>Your Email</label>
                <input v-model="formData.email" placeholder="Enter your Email" autocomplete="off">
              </div>
              <div class="form-group w-100">
                <label>Message</label>
                <textarea v-model="formData.message" placeholder="Enter your Message"></textarea>
              </div>
              <div class="error-msg" v-if="hasError">
                <img src="/img/error.svg">
                {{errorMessage}}
              </div>
              <div class="w-100 mt-20 text-center">
                <a href="#3" class="btn" @click="submitForm">Send The Message</a>
              </div>
            </form>
            <div class="thanks-box" v-if="successSent">Thank you! Your message has been sent.</div>
          </div>
          <div class="col-12">
            <nav>
              <ul>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#training">Train in Fortnite</a>
                </li>
                <li>
                  <a href="#contact">Contact Us</a>
                </li>
              </ul>
            </nav>
            <div class="copyrights text-center w-100">© 2020 Novos, All rights reserved.</div>
          </div>
        </div>
      </div>
      <div class="triangle triangle--1">
        <img src="/img/triangle.svg">
      </div>
      <div class="triangle triangle--2">
        <img src="/img/triangle.svg">
      </div>
    </footer>

    <back-to-top/>
  </main>
</template>

<script>
import { db } from '../src/db'
import { page, event } from "vue-analytics";
export default {
  components: {
    "mobile-btn": () => import("./components/mobile"),
    "back-to-top": () => import("./components/backToTop")
  },
  data() {
    return {
      menuActive: false,
      trainingOption: {
        slidesPerView: 6,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: true,
        breakpoints: {
          576: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: false
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: false
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
            centeredSlides: false
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50,
            centeredSlides: false
          }
        }
      },
      trainingSlider: [
        {
          image:
            require('./assets/img/ts16.png'),
          title: "Outplaying Your Enemies"
        },
        {
          image: require('./assets/img/ts13.png'),
          title: "Early Game Aggression"
        },
        {
          image: require('./assets/img/ts1.png'),
          title: "Sniping: From Beginner to Advanced"
        },
        {
          image:
            require('./assets/img/ts14.png'),
          title: "Close Ranged Combat"
        },
        {
          image:
            require('./assets/img/ts12.png'),
          title: "Editing: everything you need to know"
        },
        {
          image:
            require('./assets/img/ts15.png'),
          title: "Advanced Building Techniques"
        },
        {
          image:
            require('./assets/img/ts10.png'),
          title: "Sharpen Your Gamesense"
        },
        {
          image:
            require('./assets/img/ts11.png'),
          title: "Sniping 101"
        },
        {
          image:
            require('./assets/img/ts2.png'),
          title: "Aim Training"
        },
        {
          image:
           require('./assets/img/ts3.png'),
          title: "Early Game: Zero to Hero!"
        },
           {
          image:
          require('./assets/img/ts4.png'),
          title: "Optimal Settings and Keybindings"
        },
         {
          image:
           require('./assets/img/ts6.png'),
          title: "Basic Building"
        },
        {
          image:
           require('./assets/img/ts7.png'),
          title: "Shotgun Flicking Training"
        },
             {
          image:
           require('./assets/img/ts8.png'),
          title: "Improving your movement"
        },
        {
          image:
           require('./assets/img/ts9.jpg'),
          title: "1v1 Tips and Tricks"
        },
        {
          image:
          require('./assets/img/tsmap.png'),
          title: "Landing spots and Loadouts"
        },
        {
          image:
           require('./assets/img/ts2.png'),
          title: "Efficient Resources Management"
        },
      ],
      reviewsOption: {
        slidesPerView: 1,
        loop: true,
        autoplay: true,
        navigation: {
          nextEl: ".slider-btn--next",
          prevEl: ".slider-btn--prev"
        },
        pagination: {
          el: ".swiper-pagination"
        }
      },
      reviewsSlider: [
        {
          image: require('./assets/img/reviewer2.png'),
          text:
            "Finally a program that gives me everything I need to train at. Hardest part for me was figuring out which maps I need to go to in creative. Thank you NOVOS!!!",
          author: "Tychert"
        },
        {
          image:
            require('./assets/img/reviewer2.5.png'),
          text:
            "I use NOVOS daily to train. I showed the map and the tool to my 9 year old brother who loves Fortnite and he loves it as well, trains at least 5 times a day with it",
          author: "OneProudAries"
        },
        {
          image:
            require('./assets/img/reviewer3.png'),
          text:
            "Amazing training map, works well and is really optimized for beginners learning the basics and learning skrimishes. The personalized training plan covers everything you need",
          author: "goldenMarching"
        }
      ],
      articles: [
       {
          title: "Weekly Challenges",
          text:
            "Compete in challenges every week and win thousands of V-Bucks by dominating your skills!",
          link: "#3",
          image: require("./assets/img/challenges.png")
        },
          {
          title: "In-game drills",
          text:
            "Push your limits and with tailor-made drills that are focused on making you a better player!",
          link: "#3",
          image: require("./assets/img/ingamedrill.png")
        },
            {
          title: "Creative maps",
          text:
            "Stop looking for new creative codes and maps, with NOVOS you will get the best maps for you, with step-by-step practices ",
          link: "#3",
          image: require("./assets/img/analyzer.png")
        },
        {
          title: "Video guides",
          text:
            "We’ll provide you with the most relevant video guides including tips and tricks that you can apply right into your next game!",
          link: "#3",
          image: require("./assets/img/trainingPlan.png")
        }
      ],
      formData: {
        name: "",
        email: "",
        message: ""
      },
      hasError: false,
      successSent: false,
      errorMessage: "",
      newsSlider: [
        {
          href: 'https://www.calcalistech.com/ctech/articles/0,7340,L-3757662,00.html',
          image: require('./assets/img/news/news-calcalist.png'),
        },
        {
          href: 'https://www.geektime.co.il/novos-raised-750000/',
          image: require('./assets/img/news/news-geek.png'),
    
        },
        {
          href: 'https://techcrunch.com/2019/09/17/remagine-secures-35m-fund-backed-by-media-giants-to-focus-on-entertainment-and-media-tech/',
          image: require('./assets/img/news/news-tc.png'),
        },
        {
          href: 'https://esportsobserver.com/novos-750k-funding/',
          image: require('./assets/img/news/news-teo.png'),
        },
        {
          href: 'https://www.vccafe.com/2019/07/07/spotlight-on-novos-the-training-platform-for-gamers/',
          image: require('./assets/img/news/news-vccafe.png'),
        }
      ]
    };
  },
  mounted: function() {
    page("/");
    event("bg", "landingOpen");
  },
  methods: {
    sendMessageToFirestore: function(name = this.formData.name, email = this.formData.email, message = this.formData.message) {
      db.collection('fortnite-landing-page').add({
        timeStamp: new Date(),
        name: name,
        email: email,
        message: message
      })
    },
    gaEventWrapper: function(category, action, label, callback, payload) {
      event(category, action, label)
      callback(payload)
    },
    ctaWrapper: function(label) {
      this.gaEventWrapper('CTA-click', "clickOnCTA", label, () => {
          window.open('https://download.overwolf.com/install/Download?Name=NOVOS+Fortnite+Training&ExtensionId=jpcejgcpagdkeadgjjdlnbonhnkibamplcnmhpmi&Channel=website')

      })

    },
    showMenu() {
      this.menuActive = !this.menuActive;
    },
    handleScroll(evt, el) {
      if (window.scrollY > 50) {
        el.classList.add("fixed");
      } else {
        el.classList.remove("fixed");
      }
    },
    submitForm() {
      event("form", "submit");
      this.hasError = false
      this.errorMessage = ""
      let [error, errorMessage] = this.checkIfFormNotValid();
      if (error) {
        this.errorMessage = errorMessage;
        this.hasError = true
        return;
      }
      this.sendMessageToFirestore();
      [this.formData.name, this.formData.email, this.formData.message] = ["", "", ""]
      this.successSent = true;
      setTimeout(() => (this.successSent = false), 3000);
    },
    checkIfFormNotValid: function() {
      let {name, email, message} = this.formData;
      if (name === "") {
        return [true, "Please enter a valid name"];
      }
      if (email === "") {
        return [true, "Please enter a valid email"];
      }
      if (message === "") {
        return [true, "Please enter a message"];
      }
      return [false, false];
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");
@import "style/bootstrap-grid.css";
@import "style/variables";
a {
        cursor: pointer;

}
html {
  scroll-behavior: smooth;
}
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif;
}
* {
  box-sizing: border-box;
}
.text-center {
  text-align: center;
}

.btn {
  display: inline-block;
  background: linear-gradient(
    135deg,
    rgba(217, 39, 121, 1) 0%,
    rgba(126, 39, 124, 1) 100%
  );
  font-size: 14px;
  padding: 13px 25px;
  color: #fff;
  font-weight: 300;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: 4px 10px 4px 10px;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: linear-gradient(
      135deg,
      rgba(126, 39, 124, 1) 0%,
      rgba(126, 39, 124, 1) 100%
    );
    cursor: pointer;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  }
}
header {
  display: block;
  width: 100%;
  margin: 30px 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out;
  z-index: 99;
  &.fixed {
    margin: 0;
    background: #1f112d;
    padding: 10px 0;
  }
  .logo {
    display: inline-flex;
  }
  nav {
    display: inline-flex;
    float: right;
    ul {
      display: inline-flex;
      align-items: center;
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        a {
          color: #fff;
          padding-left: 30px;
          text-decoration: none;
          font-weight: 500;
        }
      }
    }
    @media all and (max-width: 576px) {
      display: none;
      position: fixed;
      z-index: 4;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      align-items: center;
      justify-content: center;
      background: #2f1b4b;
      padding: 40px;
      &.active {
        display: flex;
      }
      ul {
        flex-direction: column;
        width: 100%;
        display: flex;
        li {
          width: 100%;
          margin: 15px 0;
          a {
            font-size: 32px;
            font-weight: 700;
            padding: 0;
            text-align: left;
            width: 100%;
          }
        }
      }
    }
  }
}

.main-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90vh;
  background: url("./assets/main-image.png") center top no-repeat;
  background-size: cover;
  h1 {
    font-size: 52px;
    color: #fff;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }
  .h4 {
    font-size: 24px;
    margin-top: 20px;
    color: #fff;
    font-weight: 300;
  }
  .news-list{
    padding-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    @media all and (max-width: 992px) {
      display: none;
    }
    .h4{
      font-size: 18px;
      opacity: .8;
      margin-bottom: 30px;
      width: 100%;
      text-align: center;
    }
    &__item{
      margin: 0 15px;
      img{
        opacity: 0.5;
        width: 160px;
        height: 80px;
        max-height: 100px;
        max-width: 200px;
    
      }
      img:hover {
        opacity: 1;
      }
    }
  }
}
.icons-list {
  padding: 100px 0;
  &__item {
    font-size: 24px;
    color: #412a57;
    img {
      margin-bottom: 15px;
    }
    @media all and (max-width: 576px) {
      margin-top: 50px;
    }
  }
}
.article-list {
  &__item {
    padding: 100px 0;
    position: relative;
    margin: 50px 0;
    display: inline-block;
    width: 100%;
    @media all and (max-width: 576px) {
      display: flex;
      flex-direction: column;
      padding: 30px 0;
      margin: 0;
    }
  }
  &__text {
    .h3 {
      font-size: 38px;
      color: #412a57;
      margin-bottom: 25px;
    }
    p {
      color: #757887;
      line-height: 30px;
      font-size: 20px;
    }
    a {
      font-size: 17px;
      color: #412a57;
      margin-top: 20px;
      text-decoration: none;
      font-weight: 500;
      padding-right: 30px;
      background: url("./assets/arrow.png") right center no-repeat;
      transition: all 0.3s ease-in-out;
      &:hover {
        padding-right: 40px;
      }
    }
    @media all and (max-width: 576px) {
      order: 2;
    }
  }
  &__img {
    position: absolute;
    background: rgba(66, 43, 89, 1);
    background-size: cover;
    &.right-img {
      right: 0;
      top: 0;
      bottom: 0;
      width: 50%;
      border-radius: 10px 0 0 20px;
    }
    &.left-img {
      left: 0;
      top: 0;
      bottom: 0;
      width: 50%;
      border-radius: 0 10px 20px 0;
    }
    @media all and (max-width: 576px) {
      position: relative;
      width: 100% !important;
      height: 300px;
      border-radius: unset !important;
      order: 3;
      margin-top: 50px;
    }
  }
}

.training-sessions {
  padding: 80px 0;
  margin-top: 50px;
  border-top: 1px solid #e5e5e5;
  .h2 {
    font-size: 44px;
    color: #39244f;
    font-weight: 500;
  }
  p {
    font-size: 24px;
    color: #3e2854;
  }
  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 370px;
    padding: 40px 30px;
    background-position: center;
    background-size: cover;
    border-radius: 10px;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.195941);
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    transition: all 0.3s ease-in-out;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: #3b2651;
      opacity: 0.7;
      z-index: 1;
      transition: all 0.3s ease-in-out;
    }
    &:hover {
      cursor: pointer;
      &:before {
        background: transparent;
      }
    }
    .h3 {
      font-size: 24px;
      color: #fff;
      position: relative;
      z-index: 3;
      text-align: center;
      font-weight: 600;
    }
  }
}

.reviews {
  padding: 80px 0 60px;
  background: rgb(46, 28, 68);
  background: linear-gradient(145deg, #2f1d45 0%, #5a2b5e 100%);
  position: relative;
  overflow: hidden;
  .triangle {
    position: absolute;
    &.triangle--1 {
      left: 5%;
      top: -10px;
    }
  }
  .h2 {
    color: #fff;
    font-weight: 600;
    font-size: 44px;
    margin-bottom: 80px;
  }
  .slider-btn {
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    &--prev {
      img {
        transform: rotate(-180deg);
      }
    }
    &:hover {
      transform: scale(1.2);
    }
    &:focus,
    &:active {
      outline: none;
      box-shadow: none;
    }
  }
  .review-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    @media all and (max-width: 576px) {
      flex-direction: column;
    }
    &__img {
      width: 390px;
      max-width: 45%;
      height: 290px;
      border-radius: 10px 30px;
      overflow: hidden;
      @media all and (max-width: 576px) {
        width: 100%;
        max-width: 100%;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__text {
      padding: 0 50px;
      font-size: 20px;
      font-weight: 400;
      color: #fff;
      max-width: 55%;
      @media all and (max-width: 576px) {
        width: 100%;
        max-width: 100%;
      }
      span {
        margin-top: 20px;
        font-size: 16px;
      }
    }
  }
  .custom-bullets {
    bottom: 0;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .swiper-pagination-bullet {
      background: #68537e;
      border: 3px solid transparent;
      width: 10px;
      height: 10px;
      margin: 0 5px;
      opacity: 1;
      &.swiper-pagination-bullet-active {
        background: transparent;
        border-color: #d4277a;
        width: 16px;
        height: 16px;
      }
    }
  }
}

footer {
  padding: 100px 0 80px;
  position: relative;
  overflow: hidden;
  .triangle {
    position: absolute;
    &.triangle--1 {
      left: 0;
      bottom: -10px;
    }
    &.triangle--2 {
      right: 0;
      top: -10px;
      transform: rotate(180deg);
    }
  }
  .h2 {
    font-size: 44px;
    color: #39244f;
    font-weight: 600;
  }
  form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 50px;
    max-width: 100%;
    .form-group {
      display: flex;
      flex-direction: column;
      width: 48%;
      margin-bottom: 25px;
      label {
        font-size: 14px;
        color: #402a56;
        margin-bottom: 15px;
        font-weight: 600;
      }
      input,
      textarea {
        background: rgba(218, 214, 223, 0.31);
        box-shadow: inset 0px 0px 20px #dad6df;
        border-radius: 5px;
        border: unset;
        height: 50px;
        padding: 15px;
        font-size: 14px;
        font-weight: 500;
        transition: all 0.3s ease-in-out;
        &:focus,
        &:active {
          box-shadow: unset;
          outline: none;
        }
      }
      textarea {
        height: 150px;
      }
      @media all and (max-width: 576px) {
        width: 100%;
        input,
        textarea {
          font-size: 16px;
        }
      }
    }
    .error-msg {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 14px;
      color: #34214a;
      margin-bottom: 20px;
      img {
        margin-right: 20px;
      }
    }
  }
  .thanks-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 150px;
    background: rgba(197, 190, 203, 0.31);
    border-radius: 5px;
    font-size: 16px;
    color: #a99fb4;
    margin-top: 50px;
  }
  nav {
    margin-top: 70px;
    ul {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      li {
        list-style: none;
        padding: 0 15px;
        a {
          font-size: 14px;
          font-weight: 600;
          color: #34214a;
          text-decoration: none;
        }
      }
    }
  }
  .copyrights {
    color: #39244f;
    font-weight: 600;
    font-size: 13px;
    margin-top: 30px;
  }
}
</style>
